module.exports = __webpack_public_path__ + "assets/images/ldl_y.34a8274e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/ldl_y.png
// module id = 751
// module chunks = 1